export const LsInvoicingInvoicePaymentTime = 'LsInvoicingInvoicePaymentTime';

export const LsInvoicingInvoiceCreationTime = 'LsInvoicingInvoiceCreationTime';
export const LsInvoicingInvoiceFinalizationTime = 'LsInvoicingInvoiceFinalizationTime';
export const LsInvoicingCloseInvoicePreviewTime = 'LsInvoicingCloseInvoicePreviewTime';
